import React, {useContext, useEffect, useState} from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { Button } from 'react-bootstrap';
import MultipleChoice, { TMultiChoiceQuestion } from '../../../../interactive/quiz/multi-choice/MultiChoice';
import { t } from 'ttag';
import styled from 'styled-components';
import questioner from '../../characters/Turtle';
import WordDiscovery from '../../../../general/WordDiscovery'
import { CyberSecurityData } from '../..';
import toaster from 'toasted-notes';
import VoiceoverContext from '../../../../misc/voiceover-context';


const TurtleQuestion1: React.FC<ISlide<CyberSecurityData>> = ({defaultHeader, nextSlide, data}) => {
    const [show, setShow] = useState(false);
    const { playVoiceover, stopVoiceover } = useContext(VoiceoverContext);
    useEffect(() => {
        playVoiceover('turtle-question-1');
    }, [])
    const gameData: TMultiChoiceQuestion[] = [
        {
            question: t`What is personal information?`,
            answers: [
                { text: t`Asking a friend for information`, correct: false },
                { text: t`Personal equipment`, correct: false },
                { text: t`Information that is private and should not be shared with strangers `, correct: true },
            ],
            hint: t`Remember, personal information is data such as your name, date of birth or address.`,
        },
    ];

    const handleQuestionComplete = () => {
        data.addPoints(10);
        setShow(true);
        setTimeout(() => playVoiceover('term-discovered'), 400);
        setTimeout(() => playVoiceover('turtle-question-1-correct'), 2000);
    };

    return (
        <Slide header={defaultHeader} footerHidden={true}>
            <WordDiscovery
                show={show}
                onClose={() => {stopVoiceover(); nextSlide()}}
                word={t`Personal Information`}
                wordDefinition={t`Information that is private and should not be shared with strangers.`}
                title={t`TERM DISCOVERED`}
            ></WordDiscovery>
            <QuestionCard>
                <div className="island__author--dialogue">{questioner.characterName}</div>
                <Character>
                    <div>
                        <img
                            src={questioner.characterImage}
                            alt={questioner.characterName}
                            width={questioner.characterWidth}
                            height={questioner.characterHeight}
                        />
                        <Shadow />
                    </div>
                </Character>
                <MultipleChoice
                    gameData={gameData}
                    onGameComplete={() => handleQuestionComplete()}
                    onCorrectAnswer={() => {
                        playVoiceover('sound-6');
                    }}
                    onIncorrectAnswer={() => {
                        playVoiceover('sound-2');
                        setTimeout(() => playVoiceover('turtle-question-1-incorrect'), 2000);
                    }}
                    forceOnAnswer={true}
                ></MultipleChoice>
            </QuestionCard>
        </Slide>
    );
};

const Shadow = styled.div`
    border-radius: 50%;
    display: block;
    position: absolute;
    width: 100%;
    height: 40px;
    bottom: -20px;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0.4;
    -webkit-filter: blur(10px);
    -webkit-transform: scale(1, 0.2);
    z-index: 0;
`;

const Character = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(-50%) translateY(-50%);
    z-index: -1;
    img {
        position: relative;
        z-index: 2;
        max-width: 100%;
    }
`;

const QuestionCard = styled.div`
    width: 100%;
    background-color: #ffffff;
    color: #6400aa;
    max-width: 100%;
    display: block;
    margin: 20px auto 0 auto;
    position: relative;
    padding: 1.5rem 1.25rem 0.75rem 1.25rem;
    margin-top: 5rem;
    border-radius: 5px;
    max-width: 400px;
`;

export default TurtleQuestion1;
